<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
>
    <g
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
    >
        <!-- Top-left -->
        <path d="M6 14V6H14" />

        <!-- Top-right -->
        <path d="M34 6H42V14" />

        <!-- Bottom-left -->
        <path d="M6 34V42H14" />

        <!-- Bottom-right -->
        <path d="M34 42H42V34" />
    </g>
</svg>
</template>
<script>
export default {
}
</script>